import { render, staticRenderFns } from "./contract-exchange.vue?vue&type=template&id=4f519d2f"
import script from "./contract-exchange.vue?vue&type=script&lang=js"
export * from "./contract-exchange.vue?vue&type=script&lang=js"
import style0 from "./contract-exchange.vue?vue&type=style&index=0&id=4f519d2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports